import React, { Component } from "react";
import { Button, Overlay, Popover } from "react-bootstrap";
import Color from "../../assets/color";

// Component
import Icon from "../../components/Icon";
import MenuCardStyle from "./style";

class CartInput extends Component {
  handleChange = type => {
    const { value, itemPrice, deliveryPrice, itemID, option } = this.props;
    let isValid = type === "add" || !!(value - 1 >= 0);
    let newValue = value;

    if (isValid) {
      if (type === "add") {
        newValue++;
      } else if (type === "minus") {
        newValue--;
      }

      this.props.onChange(
        itemPrice,
        deliveryPrice,
        itemID,
        option,
        newValue,
        true
      );
    }
  };

  render() {
    const { id, value, popoverShow, popoverText, hideOverlay } = this.props;
    return (
      <MenuCardStyle>
        <div
          className="cart-qty d-flex align-items-center justify-content-center"
          ref={ref => {
            this[`target_cart_${id}`] = ref;
          }}
        >
          <Button
            className="m-0 p-1 d-flex btn-qty btn-minus align-items-center justify-content-center"
            onClick={() => this.handleChange("minus")}
          >
            <Icon type="custom" name="minus" color={Color.primary} size={8} />
          </Button>
          <b className="mx-3">{value}</b>
          <Button
            className="m-0 p-1 d-flex btn-qty align-items-center justify-content-center"
            onClick={() => this.handleChange("add")}
          >
            <Icon type="custom" name="add" color={Color.primary} size={8} />
          </Button>
        </div>
        <Overlay
          show={popoverShow}
          target={this[`target_cart_${id}`]}
          placement="top"
          container={this}
          onHide={hideOverlay}
          rootClose={false}
        >
          <Popover id="popover-contained">{popoverText}</Popover>
        </Overlay>
      </MenuCardStyle>
    );
  }
}

export default CartInput;
